import React from "react";
import "./LinkDropdown.css";

/**
 * LinkDropdown component
 * Closes dropdown on outside click
 *
 * @property string header (element of the top arrow element)
 * @property array children (list of components who will render in <li>)
 */
export default class LinkDropdown extends React.Component {
  state = {
    isExpanded: false
  };

  constructor(props) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mouseup", this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener("mouseup", this.handleOutsideClick);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleOutsideClick(e) {
    if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      this.setState({
        isExpanded: false
      });
    }
  }

  getTopLevelClass() {
    if (this.state.isExpanded) {
      return "LinkDropdown LinkDropdown__active";
    }

    return "LinkDropdown";
  }

  toggleState() {
    this.setState({
      isExpanded: !this.state.isExpanded
    });
  }

  render() {
    return (
      <div
        className={this.getTopLevelClass()}
        ref={this.setWrapperRef}
        title={this.props.title}
      >
        <a
          className="LinkDropdown__Header"
          onClick={this.toggleState.bind(this)}
        >
          {this.props.header}
        </a>
        <ul
          className="LinkDropdown__Menu"
          onClick={this.toggleState.bind(this)}
        >
          {React.Children.map(this.props.children, (link, key) => (
            <li className="LinkDropdown__Menu__Item" key={key}>
              {link}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LinkDropdown/LinkDropdown.js